"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Decoration = exports.Header = exports.Footer = exports.Wrapper = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
var theme_1 = require("../../../theme");
var TextVerticalSpacer_1 = __importDefault(require("../../utils/TextVerticalSpacer"));
var Decoration_1 = __importDefault(require("../Decoration"));
var BACKGROUND_COLOR = {
    transparent: 'transparent',
    white: theme_1.theme.colors.WHITE,
    grey: theme_1.theme.colors.GREY_10,
    'pale-blue': theme_1.theme.colors.PALE_BLUE_40,
    'warm-blue': theme_1.theme.colors.WARM_BLUE_30,
    pink: theme_1.theme.colors.PINK_20,
    yellow: theme_1.theme.colors.YELLOW_20,
    green: theme_1.theme.colors.GREEN_10,
};
exports.Wrapper = styled_components_1.default.section(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  background-color: ", ";\n  padding-top: ", "px;\n  padding-bottom: ", "px;\n\n  @media ", " {\n    padding-top: ", "px;\n    padding-bottom: ", "px;\n  }\n\n  @media ", " {\n    padding-top: ", "px;\n    padding-bottom: ", "px;\n  }\n"], ["\n  position: relative;\n  background-color: ", ";\n  padding-top: ",
    "px;\n  padding-bottom: ",
    "px;\n\n  @media ", " {\n    padding-top: ",
    "px;\n    padding-bottom: ",
    "px;\n  }\n\n  @media ", " {\n    padding-top: ",
    "px;\n    padding-bottom: ",
    "px;\n  }\n"])), function (_a) {
    var $backgroundColor = _a.$backgroundColor;
    return BACKGROUND_COLOR[$backgroundColor];
}, function (_a) {
    var $collapseTopPadding = _a.$collapseTopPadding, $noTopPadding = _a.$noTopPadding;
    return $noTopPadding ? 0 : $collapseTopPadding ? 20 : 40;
}, function (_a) {
    var $collapseBottomPadding = _a.$collapseBottomPadding, $noBottomPadding = _a.$noBottomPadding;
    return $noBottomPadding ? 0 : $collapseBottomPadding ? 20 : 40;
}, theme_1.theme.breakpoints.medium, function (_a) {
    var $collapseTopPadding = _a.$collapseTopPadding, $noTopPadding = _a.$noTopPadding;
    return $noTopPadding ? 0 : $collapseTopPadding ? 32 : 64;
}, function (_a) {
    var $collapseBottomPadding = _a.$collapseBottomPadding, $noBottomPadding = _a.$noBottomPadding;
    return $noBottomPadding ? 0 : $collapseBottomPadding ? 32 : 64;
}, theme_1.theme.breakpoints.large, function (_a) {
    var $collapseTopPadding = _a.$collapseTopPadding, $noTopPadding = _a.$noTopPadding;
    return $noTopPadding ? 0 : $collapseTopPadding ? 48 : 96;
}, function (_a) {
    var $collapseBottomPadding = _a.$collapseBottomPadding, $noBottomPadding = _a.$noBottomPadding;
    return $noBottomPadding ? 0 : $collapseBottomPadding ? 48 : 96;
});
var FOOTER_ALIGN = {
    center: 'center',
    left: 'flex-start',
};
exports.Footer = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: ", ";\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: ", ";\n"])), function (_a) {
    var _b = _a.$hAlign, $hAlign = _b === void 0 ? 'center' : _b;
    return FOOTER_ALIGN[$hAlign];
});
exports.Header = styled_components_1.default(TextVerticalSpacer_1.default).attrs({ level: '1' })(templateObject_3 || (templateObject_3 = __makeTemplateObject([""], [""])));
exports.Decoration = styled_components_1.default(Decoration_1.default)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  pointer-events: none;\n  user-select: none;\n  display: block;\n  margin: ", "px auto 0 auto;\n\n  @media ", " {\n    margin: ", "px auto 0 auto;\n  }\n\n  @media ", " {\n    transform: ", ";\n\n    margin: 0;\n    position: absolute;\n    top: ", ";\n    bottom: ", ";\n    left: ", ";\n    right: ", ";\n  }\n\n  @media ", " {\n    left: ", ";\n    right: ", ";\n  }\n"], ["\n  pointer-events: none;\n  user-select: none;\n  display: block;\n  margin: ", "px auto 0 auto;\n\n  @media ", " {\n    margin: ", "px auto 0 auto;\n  }\n\n  @media ", " {\n    transform: ",
    ";\n\n    margin: 0;\n    position: absolute;\n    top: ",
    ";\n    bottom: ",
    ";\n    left: ", ";\n    right: ", ";\n  }\n\n  @media ", " {\n    left: ", ";\n    right: ", ";\n  }\n"])), function (_a) {
    var $collapseBottomPadding = _a.$collapseBottomPadding;
    return ($collapseBottomPadding ? 40 : 80);
}, theme_1.theme.breakpoints.medium, function (_a) {
    var $collapseBottomPadding = _a.$collapseBottomPadding;
    return ($collapseBottomPadding ? 64 : 128);
}, theme_1.theme.breakpoints.large, function (_a) {
    var $collapseTopPadding = _a.$collapseTopPadding, $collapseBottomPadding = _a.$collapseBottomPadding, $position = _a.$position;
    return $collapseTopPadding || $collapseBottomPadding
        ? $position.startsWith('top')
            ? "translateY(-50%)"
            : "translateY(50%)"
        : 'none';
}, function (_a) {
    var $collapseTopPadding = _a.$collapseTopPadding, $position = _a.$position;
    return $position.startsWith('top') ? ($collapseTopPadding ? 0 : 96 / 2) + "px" : '';
}, function (_a) {
    var $collapseBottomPadding = _a.$collapseBottomPadding, $position = _a.$position;
    return $position.startsWith('bottom') ? ($collapseBottomPadding ? 0 : 96 / 2) + "px" : '';
}, function (_a) {
    var $position = _a.$position;
    return ($position.endsWith('left') ? 96 / 4 + "px" : '');
}, function (_a) {
    var $position = _a.$position;
    return ($position.endsWith('right') ? 96 / 4 + "px" : '');
}, theme_1.theme.breakpoints.xlarge, function (_a) {
    var $position = _a.$position;
    return ($position.endsWith('left') ? 96 / 2 + "px" : '');
}, function (_a) {
    var $position = _a.$position;
    return ($position.endsWith('right') ? 96 / 2 + "px" : '');
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
